import * as CONSTANTS from "./constants"
        
export const GetRecordDisplayed = (lang, maxRecords, page) => {
    switch(lang){
        case 'en':
            if (maxRecords > 0){
                return `In total of ${maxRecords} results, displaying ${(page - 1)*10 +1} - ${(page)*10 > maxRecords? maxRecords: (page)*10} results.`
            }
            return 'No records found.'
        case 'tc':
            if (maxRecords > 0){
                return `共有 ${maxRecords} 個結果，顯示 ${(page - 1)*10 +1} - ${(page)*10 > maxRecords? maxRecords: (page)*10} 個結果。`
            }
            return '沒有找到記錄。'
        case 'sc':
            if (maxRecords > 0){
                return `共有 ${maxRecords} 条结果，显示 ${(page - 1)*10 +1} - ${(page)*10 > maxRecords? maxRecords: (page)*10} 条结果。`
            }
            return '沒有找到記錄。'
        case 'jp':
            if (maxRecords > 0){
                return `合計 ${maxRecords} 件の結果があり、 ${(page - 1)*10 +1} - ${(page)*10 > maxRecords? maxRecords: (page)*10} 件を表示しています。`
            }
            return 'レコードが見つかりません。'
    }
};

export const GetCountryNameByCode = (lang, code) => {
    let country_name = '';
    CONSTANTS.COUNTRY_LIST.forEach(country => {
        if (country.code === code) {
            country_name = country.label[lang];
            return;
        }
    })
    return country_name
}
